import { combineEpics } from "redux-observable"
import { pricingTableItemsEpics } from "../pricing/epics"
import { contactEpics } from "./contact/epics"
import { serialNumberListingEpics } from "./serial-numbers/epics"


const combinedEpics = combineEpics(
    serialNumberListingEpics,
    contactEpics,
    pricingTableItemsEpics
)

export {
    combinedEpics
}



// WEBPACK FOOTER //
// ./src/state/listing/rootEpic.ts